module.exports = __webpack_public_path__ + "static/media/cover_image_1.c06204c4.jpg";